var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showToolbarAndNavDrawer)?_c('v-app-bar',{attrs:{"color":_vm.color,"height":"48px;","dark":""}},[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.logo,"height":"26"},on:{"click":function($event){return _vm.$router.push('/')}}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }